module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George D. Shuman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("George D Shuman")]), _vm._v(" is author of "), _c('I', [_vm._v("Lost Girls")]), _vm._v(", "), _c('I', [_vm._v("Last Breath")]), _vm._v(", and "), _c('I', [_vm._v("18 Seconds")]), _vm._v(". A retired twenty-year veteran of the Washington, D.C., Metropolitan Police Department, he resides in the mountains of southwest Pennsylvania, where he now writes full-time. To learn more, visit his website at www.georgedshuman.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oweem0/tc-custom/9781439109786.jpg?1730530306752",
      "alt": "This image is the cover for the book Second Sight, Sherry Mode"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Second Sight, Sherry Mode\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stunningly beautiful blind psychic Sherry Moore has the extraordinary gift for seeing the last eighteen seconds of a deceased person’s memory, which has helped solve numerous crimes and save countless lives. Her life has been anything but normal, but because of her relationship with Brian Metcalf, the Navy SEAL she met during a dramatic rescue on Mount McKinley, Sherry has never been happier. Then her exposure to deadly radiation changes everything. Flush with pounding action and shocking twists, Second Sight is the riveting story of an astounding heroine who, in delving into the darkest corners of the pharmaceutical trade, risks her life to set right an injustice buried deep in the past.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon & Schuster\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0